import _ from 'lodash';
import { createClient } from '@/shared/api';
import type {
  ClinicEventFilterInput,
  ClinicEventsQuery,
  ClinicEventsQueryVariables,
} from '@/shared/api';
import CLINIC_EVENTS_QUERY from '../queries/clinicEvents';

/**
 * Loads the paged list of clinic events matching a filter. Runs the clinicEvents query with the filter and limit and throws the first GraphQL error only when no events came back.
 *
 * @param filter - Filter selecting the clinic events.
 * @param limit - Maximum number of events to load; defaults to 10.
 * @returns A promise resolving to the clinic events payload.
 */
const fetchClinicEvents = async (filter: ClinicEventFilterInput, limit: number = 10) => {
  const client = createClient();
  const clinicEventsResult = await client.query<ClinicEventsQuery, ClinicEventsQueryVariables>({
    query: CLINIC_EVENTS_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data, errors } = clinicEventsResult;
  const { clinicEvents } = data;
  if (_.isNil(clinicEvents) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return clinicEvents;
};

export default fetchClinicEvents;
